import { Appearance } from '@/types';
import { getIsSingleConfigurationPrintType } from '@/model/printType/getIsSingleConfigurationPrintType';

export const getIsSingleConfigurationAppearance = (appearance: Appearance) =>
  appearance.printTypes.every(getIsSingleConfigurationPrintType);
